angular.module('bmsApp.trugreen.job', [
	'ui.router'
])
	.config([
		'$stateProvider', function config($stateProvider) {

			$stateProvider

				.state('main.trugreen.job', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/trugreen/job/templates/JobMain.html',
							controller: 'TGJobMainCtrl'
						}
					}
				})

				.state('main.trugreen.job.index', {
					url: '^/trugreen/jobs',
					views: {
						'content@main.trugreen.job': {
							templateUrl: 'ng/trugreen/job/templates/JobIndex.html',
							controller: 'TGJobIndexCtrl'
						},
						'side@main.trugreen.job': {
							templateUrl: "ng/trugreen/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Job'}
				})


				.state('main.trugreen.job.index.save', {
					url: '^/trugreen/job/save/{quoteId}',
					views: {
						'content@main.trugreen.job': {
							templateUrl: 'ng/trugreen/job/templates/JobSave.html',
							controller: 'TGJobSaveCtrl'
						},
						'side@main.trugreen.job': {
							templateUrl: "ng/trugreen/job/templates/JobIndexSide.html"
						}
					},
					ncyBreadcrumb: {label: "{{ jobId }}"}
				})

                .state('main.trugreen.job.closeJobList', {
                    url: '^/trugreen/close-visits',
					params: {
						data: null
					},
                    views: {
                        'content@main.trugreen.job': {
                            templateUrl: 'ng/trugreen/job/templates/CloseJobList.html',
                            controller: 'TGCloseJobListCtrl'
                        },
                        'side@main.trugreen.job': {
                            templateUrl: "ng/trugreen/job/templates/CloseJobSide.html"
                        }
                    },
                    ncyBreadcrumb: {label: 'Close Visits'}
                })

                .state('main.trugreen.job.index.view', {
                    url: '^/trugreen/job/view/{jobId}/{justNowConverted}',
                    views: {
                        'content@main.trugreen.job': {
                            templateUrl: 'ng/trugreen/job/templates/JobView.html',
                            controller: 'TGJobViewCtrl'
                        },
                        'side@main.trugreen.job': {
                            templateUrl: "ng/trugreen/job/templates/JobIndexSide.html"
                        }
                    },
                    ncyBreadcrumb: {label: 'Job OverView'}
                })

				.state('main.trugreen.job.closeJobList.close', {
					url: '^/trugreen/job/close/job/{jobId}/visit/{visitId}',
					views: {
						'content@main.trugreen.job': {
							templateUrl: 'ng/trugreen/job/templates/JobClose.html',
							controller: 'TGCloseJobCtrl'
						},
						'side@main.trugreen.job': {
							templateUrl: "ng/trugreen/job/templates/JobCloseSide.html"
						}
					},
					ncyBreadcrumb: {
						label: 'Job'
					}
				})

			;

		}]);
